var scope_0 = require('/home/runner/work/collectif-swing/collectif-swing/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a0a7cf8872cce17628cf3fea32937f92.js').default;
var scope_1 = require('/home/runner/work/collectif-swing/collectif-swing/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    